export default {
  delete: ({ DELETE }, idDonnee) =>
    new Promise((resolve, reject) => {
      if (!idDonnee) {
        reject(new Error(`Erreur paramètre : idDonnee non valide "${idDonnee}"`))
      }
      return DELETE(`donnees/${idDonnee}`)
        .then(reponse => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
